import { render } from "./DeniedLiquidations.vue?vue&type=template&id=019adfc3"
import script from "./DeniedLiquidations.vue?vue&type=script&lang=js"
export * from "./DeniedLiquidations.vue?vue&type=script&lang=js"

import "./DeniedLiquidations.vue?vue&type=style&index=0&id=019adfc3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__